import { render, staticRenderFns } from "./selfAccount.vue?vue&type=template&id=c7ec8bea&scoped=true&"
import script from "./selfAccount.vue?vue&type=script&lang=js&"
export * from "./selfAccount.vue?vue&type=script&lang=js&"
import style1 from "./selfAccount.vue?vue&type=style&index=1&id=c7ec8bea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7ec8bea",
  null
  
)

export default component.exports